import { AnalyticsDataFrameCardController } from './analytics-data-frame-card.controller'

function analyticsDataFrameCard () {
  return {
    restrict: 'E',
    scope: {
      data: '<',
      filterParams: '<',
      slug: '<',
      loadingDataFrames: '=',
      fullWidth: '<'
    },
    templateUrl: '/analytics/directives/analytics-data-frame-card/analytics-data-frame-card-directive.html?$$REVISION$$',
    controller: AnalyticsDataFrameCardController
  }
}

export { analyticsDataFrameCard }
